// API helper with error handling and auth support
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('session_token');
  if (token) {
    return { 'Authorization': `Bearer ${token}` };
  }
  return {};
};

export const api = {
  async get(endpoint, options = {}) {
    try {
      const res = await fetch(`${API_URL}/api${endpoint}`, {
        headers: {
          ...getAuthHeaders(),
          ...options.headers
        },
        ...options
      });
      if (!res.ok) {
        if (res.status === 401) {
          localStorage.removeItem('session_token');
          window.location.href = '/login';
          return { success: false, error: 'Unauthorized' };
        }
        throw new Error(`HTTP ${res.status}`);
      }
      return res.json();
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  async post(endpoint, data, options = {}) {
    try {
      const res = await fetch(`${API_URL}/api${endpoint}`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
          ...options.headers
        },
        body: JSON.stringify(data),
        ...options
      });
      if (!res.ok) {
        if (res.status === 401) {
          localStorage.removeItem('session_token');
          window.location.href = '/login';
          return { success: false, error: 'Unauthorized' };
        }
        const errorText = await res.text();
        throw new Error(`HTTP ${res.status}: ${errorText}`);
      }
      return res.json();
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  async put(endpoint, data, options = {}) {
    try {
      const res = await fetch(`${API_URL}/api${endpoint}`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
          ...options.headers
        },
        body: JSON.stringify(data),
        ...options
      });
      if (!res.ok) {
        if (res.status === 401) {
          localStorage.removeItem('session_token');
          window.location.href = '/login';
          return { success: false, error: 'Unauthorized' };
        }
        const errorText = await res.text();
        throw new Error(`HTTP ${res.status}: ${errorText}`);
      }
      return res.json();
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  async delete(endpoint, options = {}) {
    try {
      const res = await fetch(`${API_URL}/api${endpoint}`, {
        method: 'DELETE',
        headers: {
          ...getAuthHeaders(),
          ...options.headers
        },
        ...options
      });
      if (!res.ok) {
        if (res.status === 401) {
          localStorage.removeItem('session_token');
          window.location.href = '/login';
          return { success: false, error: 'Unauthorized' };
        }
        throw new Error(`HTTP ${res.status}`);
      }
      return res.json();
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
};

export default api;
